import * as React from "react";

import { DialogManager } from "DialogManager";

export const DialogContext: React.Context<DialogManager | undefined> = React.createContext<DialogManager | undefined>(
  undefined,
);
